"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIconForFile = void 0;
const tslib_1 = require("tslib");
const extensions = (0, tslib_1.__importStar)(require("../../components/FileViewer/fileTypeExtensions"));
function getIconForFile(options) {
    if (options.isDocument) {
        return 'documentPage';
    }
    if (options.isDirectory) {
        return 'folderColour';
    }
    if (options.isMasterFile) {
        return 'masterFile';
    }
    if (extensions.word.includes(options.ext)) {
        return 'wordFile';
    }
    if (extensions.videos.includes(options.ext)) {
        return 'videoFile';
    }
    if (extensions.spreadsheets.includes(options.ext)) {
        return 'spreadsheetFile';
    }
    if (extensions.powerpoints.includes(options.ext)) {
        return 'powerpointFile';
    }
    if (extensions.images.includes(options.ext)) {
        return 'imageFile';
    }
    if (extensions.pdf.includes(options.ext)) {
        return 'pdfFile';
    }
    return 'page';
}
exports.getIconForFile = getIconForFile;
//# sourceMappingURL=getIconForFile.js.map